module.exports = __webpack_public_path__ + "static/media/visual-studio-code.389f119b.svg";